import { Component } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { configService, Configuration } from '@unpispas/upp-base';
import { UppGridConfiguration } from '@unpispas/upp-wdgt';

interface Product {
    name: string;
    color: string;
    icon: string;
    price: string;
    stock: string;
}

@Component({
    selector: 'demo-upp-grid',
    templateUrl: './demo-upp-grid.html',
    styleUrls: ['../demo-common.scss', './demo-upp-grid.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoUppGridComponent {
    showItems = true;

    products: Product[] = [
        { name: 'Espresso', color: 'primary', icon: 'cafe-outline', price: '€2.50', stock: 'In stock' },
        { name: 'Latte', color: 'success', icon: 'cafe-outline', price: '€3.80', stock: 'In stock' },
        { name: 'Cappuccino', color: 'warning', icon: 'cafe-outline', price: '€3.50', stock: 'Low' },
        { name: 'Tea', color: 'danger', icon: 'leaf-outline', price: '€2.00', stock: 'In stock' },
        { name: 'Juice', color: 'tertiary', icon: 'nutrition-outline', price: '€4.20', stock: 'Low' },
        { name: 'Water', color: 'medium', icon: 'water-outline', price: '€1.50', stock: 'In stock' },
    ];

    private _config: Configuration;

    constructor(private config: configService, private change: ChangeDetectorRef) {
        this._config = this.config.getConfiguration('DEMO_CATALOG');
        this._config.set(UppGridConfiguration.viewmode, 'GRID');
        this._config.set(UppGridConfiguration.thumbsize, 10);
    }

    get viewMode(): string {
        return String(this._config.get(UppGridConfiguration.viewmode) || 'GRID');
    }

    get gridSize(): 'SMALL' | 'LARGE' {
        const ts = Number(this._config.get(UppGridConfiguration.thumbsize)) || 10;
        return ts >= 15 ? 'LARGE' : 'SMALL';
    }

    toggleViewMode() {
        const next = this.viewMode === 'GRID' ? 'LIST' : 'GRID';
        this._config.set(UppGridConfiguration.viewmode, next);
        this._config.commit();
        this.change.markForCheck();
    }

    toggleSize() {
        const current = Number(this._config.get(UppGridConfiguration.thumbsize)) || 10;
        const next = current >= 15 ? 10 : 15;
        this._config.set(UppGridConfiguration.thumbsize, next);
        this._config.commit();
        this.change.markForCheck();
    }

    toggleItems() {
        this.showItems = !this.showItems;
        this.change.markForCheck();
    }
}
